<template>
  <div>
    <div class="g-recaptcha" :data-sitekey="siteKey" data-callback="onSubmit" data-action="submit"></div>
  </div>
</template>

<script>
export default {
  name: 'ReCaptcha',
  data() {
    return {
      siteKey: '6LfxS3YpAAAAAEHkssdwfXRCsmxKneQ_VXjEtoOZ'
    };
  },
  methods: {
    onSubmit(token) {
      // Implement your logic to handle the token here
      this.$emit('token', token); // Emit the token to the parent component
    },
    onClick() {
      grecaptcha.ready(() => {
        grecaptcha.execute('6LfxS3YpAAAAAEHkssdwfXRCsmxKneQ_VXjEtoOZ', { action: 'submit' }).then(token => {
          // Add your logic to submit to your backend server here.
        });
      });
    },
  }
};
</script>

